var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgError = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1032_31703)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26.768,
    stroke: "#D32F2F",
    strokeWidth: 2.464
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26.768,
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.464
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.0001,
    cy: 28,
    r: 20.16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.0001,
    cy: 28,
    r: 20.16,
    fill: "#D32F2F",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.0098,
    y: 14.6795,
    width: 5.6,
    height: 16.8,
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.0098,
    y: 14.6795,
    width: 5.6,
    height: 16.8,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.0098,
    y: 34.7959,
    width: 5.6,
    height: 5.6,
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.0098,
    y: 34.7959,
    width: 5.6,
    height: 5.6,
    fill: "black",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1032_31703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error.1c5cee2bdb1b2ab182ab7eb0c86f6add.svg";